<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { Icon, ShoppingBagSolid, DeliveryTruckSolid } from "@getprovi/craft";
  import CurrentRetailerStore from "@retailer/svelte/stores/CurrentRetailerStore";
  import PickupOrDeliveryButton from "./PickupOrDeliveryButton.svelte";

  export let currentLocation: { id: number; name: string };
  export let showFulfillmentMethodButton: boolean = false;

  const dispatch = createEventDispatcher();

  const onChangeClick = (): void => {
    dispatch("openDrawer");
  };

  $: deliveryIsSelected = currentLocation.id == null;
  $: locationText = deliveryIsSelected
    ? `to ${$CurrentRetailerStore.name}`
    : `at ${currentLocation.name}`;
</script>

<div
  class="fizz-full-width fizz-surface-gray fizz-radius-medium fizz-inset-horizontal-16 fizz-inset-vertical-12"
  class:fizz-flex-row-8={showFulfillmentMethodButton}
  data-testid="pickup-or-delivery-banner"
>
  <p class="fizz-flex-row">
    <Icon
      iconName={deliveryIsSelected ? DeliveryTruckSolid : ShoppingBagSolid}
      size="icon-base"
      class="fizz-inline-4"
    />
    <span class="fizz-inline-4"
      ><strong>{deliveryIsSelected ? "Deliver " : "Pickup "}</strong>{locationText}</span
    >
  </p>
  {#if showFulfillmentMethodButton}
    <PickupOrDeliveryButton {onChangeClick} buttonText={"View options"} />
  {/if}
</div>
